export default __webpack_public_path__ + "static/media/webcam.2867e4fc.png";